import React from 'react'

const CalculatorColumnBottom = (props) => {
    return (
        <div className='calculator-box__column-bottom'>
            {props.children}
        </div>
    )
}

export default CalculatorColumnBottom